import React from "react";
import MarketingLocationPage from "./MarketingLocationPage";

export default function MarketingAgenturVillach() {
  return <MarketingLocationPage locationKey="villach" />;
}
